<form>
   <div class="sam-form-row">
      <div class="sam-form-flex-row">
         <label>{{ 'brick.brick_definitions.directory_browser.settings.auto_search_column.label' | translate }}</label>
      </div>
      <kendo-dropdownlist
         name="listening"
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         [valuePrimitive]="false"
         [defaultItem]="{ value: null }"
         [data]="searchableColumns$ | async"
         [value]="autoSearchColumn$ | async"
         (selectionChange)="changeAutoSearchColumn($event)"
      >
         <ng-template kendoAutoCompleteItemTemplate kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-dropdownlist>
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="automaticFilterOnSkillOrganisationAssociations">
         <input
            type="checkbox"
            id="automaticFilterOnSkillOrganisationAssociations"
            [checked]="automaticFilterOnSkillOrganisationAssociations$ | async"
            (click)="changeAutomaticFilterOnSkillOrganisationAssociations($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{
            'brick.brick_definitions.directory_browser.settings.automatic_filtering_on_skill_associations' | translate
         }}</label
      >
   </div>
   <div class="sam-form-row sub-setting">
      <label class="k-checkbox-label" for="retainFilterOnCallFinish">
         <input
            type="checkbox"
            id="retainFilterOnCallFinish"
            [checked]="retainFilterOnCallFinish$ | async"
            [disabled]="!(automaticFilterOnSkillOrganisationAssociations$ | async)"
            (click)="changeRetainFilterOnCallFinish$($event.currentTarget.checked)"
            class="k-checkbox"
         />{{
            'brick.brick_definitions.directory_browser.settings.retain_filter_on_call_finish_label' | translate
         }}</label
      >
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="automaticRestrictForIncomingCaller">
         <input
            type="checkbox"
            id="automaticRestrictForIncomingCaller"
            [checked]="automaticRestrictForIncomingCaller$ | async"
            (click)="changeAutomaticRestrictForIncomingCaller($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{
            'brick.brick_definitions.directory_browser.settings.automatic_filter_on_incoming_caller' | translate
         }}</label
      >
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="startNewCallOnDoubleClick">
         <input
            type="checkbox"
            id="startNewCallOnDoubleClick"
            [checked]="startNewCallOnDoubleClick$ | async"
            (click)="changeStartNewCallOnDoubleClick($event.currentTarget.checked)"
            class="k-checkbox"
         />{{
            'brick.brick_definitions.directory_browser.settings.start-new-call-on-double-click_label' | translate
         }}</label
      >
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="clearSearchBoxOnIncomingCall">
         <input
            type="checkbox"
            id="clearSearchBoxOnIncomingCall"
            [checked]="clearSearchBoxOnIncomingCall$ | async"
            (click)="changeClearSearchBoxOnIncomingCall($event.currentTarget.checked)"
            class="k-checkbox"
         />{{
            'brick.brick_definitions.directory_browser.settings.clear-search-box-on-incoming-call' | translate
         }}</label
      >
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.minimal_search_length_label' | translate }}</label>
      <kendo-numerictextbox
         class="k-form-field sam-form-control sam-form-control-full-width"
         [value]="minLengthToStartFiltering$ | async"
         [min]="0"
         [max]="100"
         format="n0"
         (valueChange)="changeMinLengthToStartFiltering$($event)"
      ></kendo-numerictextbox>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.searchable_columns.label' | translate }}</label>
      <kendo-multiselect
         class="k-form-field sam-form-control sam-form-control-full-width"
         [data]="possibleSearchableColumns$ | async"
         [popupSettings]="{ popupClass: 'hide-selected-items' }"
         [filterable]="false"
         [value]="searchableColumns$ | async"
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         (valueChange)="searchableColumnsChanged($event)"
         [valuePrimitive]="false"
         [placeholder]="'brick.brick_definitions.directory_browser.settings.searchable_columns.placeholder' | translate"
         [autoClose]="false"
      >
         <ng-template kendoMultiSelectItemTemplate kendoMultiSelectTagTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-multiselect>
   </div>

   <div class="sam-form-row" *ngIf="isAttendant$ | async">
      <label>{{
         'brick.brick_definitions.directory_browser.settings.searchable_columns_phonetic.label' | translate
      }}</label>
      <kendo-multiselect
         class="k-form-field sam-form-control sam-form-control-full-width"
         [data]="possiblePhoneticSearchableColumns$ | async"
         [popupSettings]="{ popupClass: 'hide-selected-items' }"
         [filterable]="false"
         [value]="searchablePhoneticColumns$ | async"
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         (valueChange)="searchablePhoneticColumnsChanged($event)"
         [valuePrimitive]="false"
         [placeholder]="
            'brick.brick_definitions.directory_browser.settings.searchable_columns_phonetic.placeholder' | translate
         "
         [autoClose]="false"
      >
         <ng-template kendoMultiSelectItemTemplate kendoMultiSelectTagTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-multiselect>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.callable_columns.label' | translate }}</label>
      <kendo-multiselect
         class="k-form-field sam-form-control sam-form-control-full-width"
         [data]="possibleSearchableColumns$ | async"
         [popupSettings]="{ popupClass: 'hide-selected-items' }"
         [filterable]="false"
         [value]="callableColumns$ | async"
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         (valueChange)="callableColumnsChanged($event)"
         [valuePrimitive]="false"
         [placeholder]="'brick.brick_definitions.directory_browser.settings.callable_columns.placeholder' | translate"
         [autoClose]="false"
      >
         <ng-template kendoMultiSelectItemTemplate kendoMultiSelectTagTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-multiselect>
   </div>

   <div class="sam-form-row">
      <div class="sam-form-flex-row">
         <label>{{ 'brick.brick_definitions.directory_browser.settings.default_call_column.label' | translate }}</label>
         <div>
            <fa-icon class="sam-center icon-faded" [icon]="defaultDial" [fixedWidth]="true"></fa-icon>
         </div>
      </div>
      <kendo-dropdownlist
         name="gender"
         samwebAutoFocus
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         [valuePrimitive]="false"
         [data]="callableColumns$ | async"
         [value]="defaultCallableColumn$ | async"
         (selectionChange)="changeDefaultCallColumn($event)"
      >
         <ng-template kendoAutoCompleteItemTemplate kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.default_sort_column.label' | translate }}</label>
      <kendo-dropdownlist
         name="gender"
         samwebAutoFocus
         valueField="directoryColumnKey"
         textField="directoryColumnKey"
         [valuePrimitive]="false"
         [data]="availableColumns$ | async"
         [value]="defaultSortableColumn$ | async"
         (selectionChange)="changeDefaultSortColumn($event)"
      >
         <ng-template kendoAutoCompleteItemTemplate kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem | directoryColumnTitle | async }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.selected_directory.label' | translate }}</label>
      <kendo-dropdownlist
         name="gender"
         samwebAutoFocus
         valueField="id"
         textField="id"
         [disabled]="!(directoryStructureData$ | async)"
         [valuePrimitive]="false"
         [data]="directoryStructureData$ | async"
         [value]="selectedDirectory$ | async"
         (selectionChange)="changeSelectedDirectory($event)"
      >
         <ng-template kendoAutoCompleteItemTemplate kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.orgnam }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.hotkeys.label' | translate }}</label>
   </div>

   <div class="sam-margin">
      <kendo-listview [data]="availableHotkeyTypes" fxFlex="1 1 auto">
         <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
            <samweb-directory-hotkey-setting
               fxFlex="1 1 auto"
               class="dataItem"
               [disabled]="!(isFeatureEnabled$ | async)"
               [shortcutTyp]="dataItem"
               [searchValue$]="searchValue$"
               [brickInstanceId]="brickInstanceId"
            ></samweb-directory-hotkey-setting>
         </ng-template>
      </kendo-listview>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.directory_browser.settings.appointments.label' | translate }}</label>
      <label class="sub-setting">{{
         'brick.brick_definitions.directory_browser.settings.appointments.standard_view' | translate
      }}</label>
      <kendo-dropdownlist
         class="sub-setting"
         [data]="appointmentViews"
         [value]="selectedAppointmentView$ | async"
         (selectionChange)="changeAppointmentView($event)"
         valueField="value"
         textField="value"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.translationKey | translate }}
         </ng-template>
      </kendo-dropdownlist>
   </div>
   <div class="sam-form-row sub-setting">
      <label class="k-checkbox-label" for="appointmentsShowBusinessHours">
         <input
            type="checkbox"
            id="appointmentsShowBusinessHours"
            [checked]="appointmentsShowBusinessHours$ | async"
            (click)="changeAppointmentsShowBusinessHours($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.directory_browser.settings.appointments.show_business_hours' | translate }}</label
      >
   </div>
</form>
